import { render, staticRenderFns } from "./znYuan.vue?vue&type=template&id=0fac0b2e&scoped=true&"
import script from "./znYuan.vue?vue&type=script&lang=js&"
export * from "./znYuan.vue?vue&type=script&lang=js&"
import style0 from "./znYuan.vue?vue&type=style&index=0&id=0fac0b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac0b2e",
  null
  
)

export default component.exports